<template>
  <v-app>
    <dashboard-core-app-bar />

    <dashboard-core-drawer />

    <dashboard-core-view />

    <!-- <dashboard-core-settings /> -->

    <confirm ref="confirm" />
    <snackbar ref="snackbar" />

    <WelcomeModal />
    <UpgradeModal :isIndex="true" :isModalActive.sync="isUpgradeModalActive" />
  </v-app>
</template>

<script>
import Confirm from './components/core/Confirm'
import Snackbar from './components/core/Snackbar'
import WelcomeModal from '@/views/WelcomeModal'
import UpgradeModal from '@/views/components/common/upgrade/UpgradeModal'

export default {
  components: {
    DashboardCoreAppBar: () => import('./components/core/AppBar'),
    DashboardCoreDrawer: () => import('./components/core/Drawer'),
    // DashboardCoreSettings: () => import('./components/core/Settings'),
    DashboardCoreView: () => import('./components/core/View'),
    Confirm,
    Snackbar,
    WelcomeModal,
    UpgradeModal,
  },
  data: () => ({
    expandOnHover: false,
    isUpgradeModalActive: false,
  }),
  mounted() {
    this.$root.$confirm = this.$refs.confirm.open
    this.$root.$snackbar = this.$refs.snackbar
  },
}
</script>
